export default __webpack_public_path__ + "static/media/feature_image_4.8dbb5697.webp";